import { Fragment, useState } from 'react';
import { Trans } from '@lingui/macro';
import { Button, Card, IconButton, SidebarHeader, Typography, Link } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { Link as RouterLink } from 'react-router-dom';
import { ThemeSelector } from 'app/domains/common-ui';
import { AccountSummaryItem } from './AccountSummaryItem';
import { CompanyItems } from './CompanyItems';
import { LanguageSelector } from './LanguageSelector';
import { Trigger } from './Trigger';
import { StyledDrawer, StyledSidebar, CardContainer, SignOutActionContainer, AvatarCardContent, } from './styled';
export function UserAccountAvatar() {
    const [open, setOpen] = useState(false);
    const handlePrivacySettingsClick = () => {
        var _a, _b;
        if (Boolean(window.UC_UI) && typeof ((_a = window.UC_UI) === null || _a === void 0 ? void 0 : _a.showSecondLayer) === 'function') {
            (_b = window.UC_UI) === null || _b === void 0 ? void 0 : _b.showSecondLayer();
        }
    };
    return (<Fragment>
      <Trigger open={open} onClick={() => setOpen(!open)}/>
      <StyledDrawer open={open} onClose={() => setOpen(false)} position="right">
        <StyledSidebar>
          <SidebarHeader>
            <Typography $fontSize="huge" $fontWeight="medium">
              <Trans comment="User account right sidebar header ">User account</Trans>
            </Typography>
            <IconButton $round appearance="ghost" size="small" onClick={() => setOpen(false)}>
              <Falcon icon="close"/>
            </IconButton>
          </SidebarHeader>

          <CardContainer>
            <Card>
              <AvatarCardContent>
                <AccountSummaryItem />
                <SignOutActionContainer>
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <Link as="button" onClick={handlePrivacySettingsClick}>
                    <Trans comment="Privacy settings link text">Privacy settings</Trans>
                  </Link>
                  <Button size="small" as={RouterLink} to="/logout">
                    <Trans comment="Sign out button text">Sign out</Trans>
                  </Button>
                </SignOutActionContainer>
              </AvatarCardContent>
            </Card>

            <ThemeSelector />
            <CompanyItems />
            <LanguageSelector />
          </CardContainer>
        </StyledSidebar>
      </StyledDrawer>
    </Fragment>);
}
